import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { useDependencies } from '@xengage/gw-portals-dependency-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import {
    ViewModelForm,
    withViewModelService,
} from '@xengage/gw-portals-viewmodel-react';
import { WizardPage, wizardProps } from '@xengage/gw-portals-wizard-react';
import React, { useCallback } from 'react';
import useAccordionStates from '../../hooks/useAccordionStates';
import useExposures from '../../hooks/useExposures';
import './ExposuresPage.messages';
import presentationMetadata from './ExposuresPage.metadata.json5';
import styles from './ExposuresStyles.module.scss';

function ExposuresPage(props) {
    const { authHeader } = useAuthentication();
    const { wizardData, updateWizardData, currentStep } = props;
    const { LoadSaveService } = useDependencies('LoadSaveService');
    const { pageKey } = currentStep;
    const metadata = presentationMetadata[pageKey];
    const { isComponentValid, initialValidation, onValidate } =
        useValidation('ExposuresPage');

    const onNext = useCallback(async () => {
        wizardData.value = await LoadSaveService.updateDraftSubmission(
            wizardData.value,
            authHeader
        );
        return wizardData;
    }, [wizardData]);

    const { addExposure, deleteExposure } = useExposures({
        ownerVM: wizardData,
    });

    const { openAccordions, accordionCallbackProps, renderKey } =
        useAccordionStates({
            ownerVM: wizardData,
        });

    const addNewExposure = useCallback(
        callbackProps => {
            addExposure(callbackProps);
            openAccordions(callbackProps);
        },
        [addExposure]
    );

    const overrideProps = {
        ...accordionCallbackProps(),
    };

    return (
        <WizardPage
            skipWhen={() => initialValidation}
            disableNext={!isComponentValid}
            onNext={onNext}
        >
            <div key={renderKey()}>
                <ViewModelForm
                    uiProps={metadata.content}
                    model={wizardData}
                    onModelChange={updateWizardData}
                    callbackMap={{
                        addExposure: addNewExposure,
                        deleteExposure,
                        onValidate: onValidate,
                    }}
                    overrideProps={overrideProps}
                    onValidationChange={onValidate}
                    classNameMap={styles}
                />
            </div>
        </WizardPage>
    );
}

ExposuresPage.propTypes = wizardProps;
export default withViewModelService(ExposuresPage);
